import { render, staticRenderFns } from "./GlobalRoleBindings.vue?vue&type=template&id=1ee86e0a&scoped=true&"
import script from "./GlobalRoleBindings.vue?vue&type=script&lang=js&"
export * from "./GlobalRoleBindings.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRoleBindings.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GlobalRoleBindings.vue?vue&type=style&index=1&id=1ee86e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee86e0a",
  null
  
)

export default component.exports